import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://elevatededucation.ca';
const DEFAULT_OG_IMAGE = 'https://customer-assets.emergentagent.com/job_elevated-apply/artifacts/myyz19wz_transparent%20logo.png';

/**
 * Reusable SEO component – injects per-page <title>, meta description,
 * canonical URL, Open Graph + Twitter Card tags, and optional JSON-LD schema.
 *
 * Usage:
 *   <SEO
 *     title="..."
 *     description="..."
 *     path="/programs"
 *     schema={{ ... }}     // single object or array of objects
 *   />
 */
export const SEO = ({
  title,
  description,
  path = '/',
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  schema,
  noindex = false,
}) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title
    ? `${title} | Elevated Education`
    : 'Elevated Education | Education Consulting in Canada';
  const desc =
    description ||
    'Elevated Education is a Canadian education consulting agency helping students apply to BC career colleges. Book a free consultation today.';

  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Elevated Education" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_CA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export const SITE_URL_CONST = SITE_URL;
